import { getHash } from './math'
const handlers = {}

export function requestAnimationFrameAsync() {
  return new Promise(resolve => requestAnimationFrame(resolve))
}

export function listenToTransitionEnd(element, animatedProps, callback, options = {}) {
  if (!element.__uniqueHashId__) element.__uniqueHashId__ = getHash()
  if (handlers[element.__uniqueHashId__]) return

  handlers[element.__uniqueHashId__] = e => {
    const isAnimatedProperty = animatedProps.some(prop => e.propertyName === prop)

    if (e.target === element && isAnimatedProperty) {
      if (options.once) {
        element.removeEventListener('transitionend', handlers[element.__uniqueHashId__])
        delete handlers[element.__uniqueHashId__]
      }
      callback()
    }
  }
  element.addEventListener('transitionend', handlers[element.__uniqueHashId__])
}

export function listenToTransitionEndOnce(element, animatedProps, callback) {
  listenToTransitionEnd(element, animatedProps, callback, { once: true })
}

export function shakeElement(element) {
  if (element.__isShaking__) return

  element.__isShaking__ = true
  element.classList.add('shake-animation')

  const onAnimationEnd = e => {
    if (e.animationName === 'shake') {
      element.removeEventListener('animationend', onAnimationEnd)
      element.classList.remove('shake-animation')
      element.__isShaking__ = false
    }
  }
  element.addEventListener('animationend', onAnimationEnd)
}

export function wait(delay) {
  return new Promise(resolve => setTimeout(resolve, delay))
}
